module.exports = __webpack_public_path__ + "assets/img/ProduceArticles.328037cd.png";